import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormikContextType } from 'formik';
import { useTranslation } from 'react-i18next';
import { StaffRoleErrors } from '../../../types';
import { handleAccordionCheckboxChange } from './StaffRoleForm';
import FormikNumberField from '../../../components/formikComponents/FormikNumberField';
import { STAFF_ROLES_CACHE_KEY } from '../../../constants';

const RefundsForm = ({
  formik,
  objectId,
  currency,
  errors,
  clearError,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikContextType<any>;
  objectId: string;
  currency: string;
  errors: StaffRoleErrors;
  clearError: (errorKey: string) => void;
}) => {
  const { t } = useTranslation();
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  return (
    <Accordion
      expanded={accordionExpanded}
      onChange={(_event, isExpanded) => setAccordionExpanded(isExpanded)}
      sx={{
        boxShadow: 0,
        padding: 0,
        margin: 0,
        '&.MuiAccordion-root.Mui-expanded': {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="refunds-panel"
        sx={{
          marginLeft: '-0.5rem',
          padding: 0,
          minHeight: '42px',
          '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: '42px',
          },
          '& .MuiAccordionSummary-content.MuiAccordionSummary-contentGutters, & .MuiAccordionSummary-expandIconWrapper':
            {
              margin: 0,
            },
        }}
        onClick={(event) => {
          event.stopPropagation();
          setAccordionExpanded(!accordionExpanded);
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, marginRight: '0.5rem' }}>
            <Checkbox
              id="discountOptsRefunds"
              name="discountOptsRefunds"
              checked={formik.values.discountOptsRefunds}
              onChange={handleAccordionCheckboxChange(formik, objectId, ['discountOptsRefunds'])}
              onClick={(event) => event.stopPropagation()}
            />
            <Typography>{t('screens.staffRoles.allow_discountOptsRefunds')}</Typography>
          </Box>
        </Box>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          paddingY: '0.5rem',
          paddingX: 0,
        }}
      >
        <Box
          sx={{
            border: '1px solid',
            borderColor: (currTheme) =>
              currTheme.palette.mode === 'light'
                ? currTheme?.palette?.grey?.['12p']
                : currTheme?.palette?.grey?.['23p'],
            borderRadius: '8px',
            padding: '0.5rem',
          }}
        >
          <Typography variant="body2" sx={{ marginBottom: '1rem' }}>
            {t('screens.staffRoles.defaultNoLimit')}
          </Typography>
          <FormikNumberField
            label={t('screens.staffRoles.discountOptsRefundLimit')}
            id="discountOptsRefundLimit"
            name="discountOptsRefundLimit"
            sx={{ marginBottom: '0.5rem' }}
            maxValue={9999999}
            minValue={0}
            decimalScale={2}
            prefix={currency}
            formName={STAFF_ROLES_CACHE_KEY}
            objectId={objectId}
            error={errors?.discountOptsRefundLimit}
            clearError={clearError}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default RefundsForm;
